import { useNavigate } from 'react-router-dom';
import { SideNavigationMenu } from '../../components';
import './menu.scss';
import { useCallback, useState } from 'react';
import { ClickEvent } from 'devextreme/ui/button';
import { useMenuPatch } from '../../utils/patches';
import { ItemClickEvent } from 'devextreme/ui/tree_view';

export default function MenuPage() {

	const navigate = useNavigate();
	const [patchCssClass, onMenuReady] = useMenuPatch();
	const [menuStatus, setMenuStatus] = useState(MenuStatus.Opened);

	const toggleMenu = useCallback(({ event }: ClickEvent) => {
		event?.stopPropagation();
	}, []);

	const temporaryOpenMenu = useCallback(() => {}, []);

	const onNavigationChanged = useCallback(({ itemData, component, event, node }: ItemClickEvent) => {
		if (menuStatus === MenuStatus.Closed) {
			event?.preventDefault();
			return;
		}

		if (itemData?.path) {
			navigate(itemData.path);
		}
		else if (!itemData?.onClick) {
			if (itemData?.items && itemData?.items.length > 0) {
				component.expandItem(itemData);
				navigate(itemData?.items[0].path);
			}
		}
	}, [navigate, menuStatus, true]);

	return (
		<div className='menuPane'>
			<SideNavigationMenu
				compactMode={false}
				selectedItemChanged={onNavigationChanged}
				openMenu={temporaryOpenMenu}
				onMenuReady={onMenuReady}
				toggleMenu={toggleMenu}
				showToggleMenuButton={false}
			>
			</SideNavigationMenu>
		</div>
	)
}

const MenuStatus = {
	Closed: 1,
	Opened: 2,
	TemporaryOpened: 3
};